import React, { Component } from 'react';
import { Select } from 'antd';
import { queryOrgCompanyList } from '@api/core/org';

const { Option } = Select;

class CompanySearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyList: [],
      companyUuid: '',
    };
  }

  async componentDidMount() {
    const { companyName, companyUuid } = this.props;
    companyName
      ? this.setDefaultOrgCompanyList(companyName, companyUuid)
      : this.getOrgCompanyList();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.companyName !== this.props.companyName) {
      const { companyName, companyUuid } = nextProps;
      companyName
        ? this.setDefaultOrgCompanyList(companyName, companyUuid)
        : this.setState({
            companyUuid: '',
          });
    }
  }

  onSelect = e => {
    this.setState({
      companyUuid: e,
    });
  };

  handleSearch = value => {
    this.getOrgCompanyList(value);
  };

  // 正常公司列表
  getOrgCompanyList = value => {
    queryOrgCompanyList({
      condition: value || '',
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          companyList: res.data,
        });
      }
    });
  };

  // 用于做默认值的公司列表
  setDefaultOrgCompanyList = async (value, uuid) => {
    await this.getOrgCompanyList();
    queryOrgCompanyList({
      condition: value || '',
    }).then(res => {
      const { companyList } = this.state;
      if (res.statusCode === 200 && res.data.length > 0) {
        const companyUuid = uuid || res.data[0].uuid;
        res.data.map(item => {
          companyList.every(it => item.uuid !== it.uuid) && companyList.push(item);
          return item;
        });
        this.setState({
          companyList,
          companyUuid,
        });
      }
    });
  };

  render() {
    const { companyList } = this.state;
    return (
      <Select
        onChange={this.props.onChange}
        onSelect={this.onSelect}
        showSearch
        filterOption={false}
        onSearch={this.handleSearch}
        value={this.state.companyUuid}
        placeholder="请搜索公司名称"
      >
        {companyList.map(item => {
          return (
            <Option key={item.uuid} value={item.uuid}>
              {item.name}
            </Option>
          );
        })}
      </Select>
    );
  }
}

export default CompanySearch;



// WEBPACK FOOTER //
// ./src/components/comm/companySearch.js